module.exports = __webpack_public_path__ + "img/logo-proteauto.0515fa5c.png";